module.exports = __webpack_public_path__ + "static/media/thymeleaf.9fca8b3b.png";